import { render, staticRenderFns } from "./MemoShow.vue?vue&type=template&id=8307846c&"
import script from "./MemoShow.vue?vue&type=script&lang=js&"
export * from "./MemoShow.vue?vue&type=script&lang=js&"
import style0 from "./MemoShow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports